<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Mary Simpson (known to her friends as ‘Champagne Mary’) retired after a career in law spanning over 40 years. After retirement, she attained a degree with merit in creative writing and then an MA in creative writing, also with merit. In addition to her first novel of this quartet, she has had several collections of poetry published. Apart from her writing, her interests are in wine and the theatre. This quartet spans seven decades in the life of its heroine, who was born during the Battle of Britain.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?86be0eb2